import { createRouter, createWebHistory } from 'vue-router'
import { currentIdToken } from './auth'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('./views/LoginView.vue'), meta: { public: true } },
    { path: '/', name: 'overview', component: () => import('./views/OverviewView.vue') },
    { path: '/alertas', name: 'alerts', component: () => import('./views/AlertsView.vue') },
    { path: '/equipe', name: 'team', component: () => import('./views/TeamView.vue') },
    { path: '/contas', name: 'organizations', component: () => import('./views/OrganizationsView.vue') },
    { path: '/contas/:id', name: 'organization', component: () => import('./views/OrganizationView.vue'), props: true },
    {
      path: '/contas/:id/videos/:videoId',
      name: 'video',
      component: () => import('./views/VideoView.vue'),
      props: true,
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  if (to.meta.public) return true
  const token = await currentIdToken()
  if (!token) return { name: 'login', query: { next: to.fullPath } }
  return true
})
